/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da .svg 
 */
export default styled.svg`
  height: 16px;
  /* margin: 13px 0 9px 18px; */

  path {
    fill: white;
  }

  #globe {
    transform: rotateZ(0);
    animation-name: rotate;
    animation-duration: 10s;
    animation-delay: 3s;
    animation-fill-mode: ease-in-out;
    animation-iteration-count: infinite;
    transform-origin: 31.654px center;
  }

  @keyframes rotate {
    30% {
      transform: rotateZ(180deg);
    }

    75% {
      transform: rotateZ(500deg);
    }

    100% {
      transform: rotateZ(720deg);
    }
  }
`;
